import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=7e0bdb39&lang=pug"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0bdb39')) {
      api.createRecord('7e0bdb39', component.options)
    } else {
      api.reload('7e0bdb39', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=7e0bdb39&lang=pug", function () {
      api.rerender('7e0bdb39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/MainLayout.vue"
export default component.exports